import { flagsDictionary } from "@kamae-apps/shared/Components/Fondations/Flags/FlagsDictonnary"
import { FC } from "react"
export type FlagVariants = "fr" | "en" | "es" | "de" | "pt" | "it"
type FlagSizes = "xs" | "s" | "m"
type FlagsProps = {
  variant: FlagVariants
  size?: FlagSizes
}

export const AVAILABLE_LANGUAGES: FlagVariants[] = ["fr", "en", "es", "de", "pt", "it"]

const flagSizeToClasses = Object.freeze({
  xs: "w-4 h-3 rounded-[2px]",
  s: "w-8 rounded-[3px]",
  m: "w-13 rounded-[4px]",
})

export const Flag: FC<FlagsProps> = ({ variant, size = "xs" }) => {
  const path = flagsDictionary[variant]
  const sizeClass = flagSizeToClasses[size]
  return (
    <svg
      className={sizeClass}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {path}
    </svg>
  )
}

export const availableLanguage = (featureFlag: string[]): FlagVariants[] => {
  return AVAILABLE_LANGUAGES.filter(lang => {
    if (lang === "es" && !featureFlag.includes("spanish")) return false
    if (lang === "de" && !featureFlag.includes("german")) return false
    if (lang === "pt" && !featureFlag.includes("portuguese")) return false
    if (lang === "it" && !featureFlag.includes("italian")) return false
    return true
  })
}
